import ViewCad from "../../../view";
import { FornecedorViewProps } from "../forn.controll";
import { Fornecedor } from "../forn.model";

interface FornecedorCadastroProps extends FornecedorViewProps {
    handleCloseView: () => any
}

export function FornecedorCadastro(props: FornecedorCadastroProps) {
    const { fornecedorActions, fornecedorState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = fornecedorState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = fornecedorActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Fornecedor) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Fornecedor) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do fornecedor"
        return errors
    }

    const handleUpdate = (value: Fornecedor) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Fornecedor",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo fornecedor",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "nome", label: "Razão Social", type: "text", key: "nome", colunsXS: 12, colunsSM: 6, colunsMD: 8, require: true },
            { fieldName: "apelido", label: "Nome Fantasia", type: "text", key: "apelido", colunsXS: 12, colunsSM: 12, colunsMD: 4, require: false, },
            { fieldName: "tipo_doc", label: "", type: "radio", key: "tipo_doc", colunsXS: 12, colunsSM: 5, colunsMD: 5, require: true, radioDefaultValue: "CNPJ", radioOptionsValues: [{ label: "CNPJ", value: "CNPJ" }, { label: "CPF", value: "CPF" }] },
            { fieldName: "n_doc", label: "N° Documento", type: "text", key: "n_doc", colunsXS: 12, colunsSM: 7, colunsMD: 7, require: false },
            { fieldName: "whatsapp", label: "Whatsapp", type: "text", maskInputText: "99 9 9999-9999", key: "whatsapp", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true },
            { fieldName: "fone", label: "Fone", type: "text", key: "fone", colunsXS: 12, colunsSM: 6, colunsMD: 4 },
            { fieldName: "email", label: "Email", type: "text", key: "email", colunsXS: 12, colunsSM: 6, colunsMD: 4 },
        ],
    })

    return viewCad
}



